import UnregisterPaymentRoute from './UnregisterPaymentRoute';

export default UnregisterPaymentRoute;
